<div style="padding: 0px 30px; height: 100%; overflow: auto;">
    <div>
        <div class="qb-header-wrapper">
            <app-breadcrumb></app-breadcrumb>
            <button class="primary-button qb-create-new-offer-button"
            [matTooltip]="'COMMON_PAGE.SEND_REPORT_EMAIL' | i18nTranslate" appButtonDebounce
            [throttleTime]="600" (throttledClick)="sendReportViaEmail()" data-button-name="Create New Offer"
            [disabled]="reportType.toUpperCase() === 'MEMBERSHIP_REPORT' && (selectedMemberships.length === 0 || selectedStatus.length === 0)">
            Send Via Email
            </button>
        </div>
        <div class="qb-main-report-header">
            <div class="qb-heading-report" *ngIf="reportType.toUpperCase() === 'MEMBERSHIP_REPORT'">
                <h4>Membership Report<span style="color: #E55151;">*</span></h4>
            </div>
            <div class="qb-heading-report" *ngIf="reportType.toUpperCase() === 'MEMBERSHIP_CHECKIN_REPORT'">
                <h4> Check In Report</h4>
            </div>
            <div class="qb-d-flex">
                <div class="qb-filters-div-report qb-mb-25 qb-filter-padding">
                    <div *ngIf="reportType.toUpperCase() === 'MEMBERSHIP_REPORT' " class="kpi-path-selection">
                        <div>
                            <div class="qb-heading-select">
                               Select Membership
                            </div>
                            <div class="mat-select-report-filter">
                                    <mat-select multiple [(ngModel)]="selectedMemberships" placeholder="Select Membership">
                                        <mat-option *ngFor="let membership of membershipTiers" [value]="membership.id.toString()">
                                            {{ membership.tierName }}
                                        </mat-option>
                                    </mat-select>
                            </div>
                        </div>

                        <div>
                            <div class="qb-heading-select">
                                Select Status
                            </div>
                            <div class="mat-select-report-filter">
                                    <mat-select multiple [(ngModel)]="selectedStatus" placeholder="Select Status">
                                        <mat-option *ngFor="let status of typeOfStatus" [value]="status.type">
                                            {{ status.type }}
                                        </mat-option>
                                    </mat-select>
                            </div>
                        </div>
                    </div>

                   
                </div>
            </div>
            <div class="qb-ilustration-add-customer">
                <img src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/illustrations/Checklist-removebg-preview.png"
                    alt="" style="width: 350px; height:300px; margin-top: 30px">
            </div>
        </div>
    </div>
</div>